var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcontecnologia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F4EF6",
    d: "M26 13a13 13 0 1 0-13 13h.135A12.878 12.878 0 0 0 26 13.135V13Zm-2.167 0c0 .964-.13 1.924-.389 2.852a.542.542 0 0 1-.737.354 3.774 3.774 0 0 1-1.644-1.374l-2.403-3.605a2.709 2.709 0 0 0-2.253-1.206h-.469a2.98 2.98 0 1 1 0-5.958h3.003c.112 0 .222.034.313.1A10.826 10.826 0 0 1 23.834 13ZM2.361 11.001a.542.542 0 0 1 .532-.433H7.59a3.767 3.767 0 0 1 2.681 1.11l1.211 1.214a3.791 3.791 0 0 1 .152 5.2l-1.472 1.656a2.708 2.708 0 0 0-.684 1.8v.897a.542.542 0 0 1-.758.496A10.833 10.833 0 0 1 2.167 13c0-.67.066-1.34.194-1.999Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcontecnologia);
export default __webpack_public_path__ + "static/media/icon tecnologia.74880c068f3e33fbe3834795994eda48.svg";
export { ForwardRef as ReactComponent };